const productMappings = {
    jet: 'Jet',
    'manager-agents': 'Media Agents',
    flight: 'Flight',
    'media-shuttle': 'Media Shuttle',
};

export function getPathFromUrlString(urlString) {
    const regex = /.+?\:\/\/.+?(\/.+?)(?:#|\?|$)/g;
    let match = regex.exec(urlString);
    if (match === null || match.length < 2) {
        return '/';
    }
    return match[1];
}

export function getProductNameFromUrlString(urlString, decode = true) {
    const regex = /^\/(\w+-?\w+)\/?/g;
    const path = getPathFromUrlString(urlString);
    const match = regex.exec(path);
    if (match == null || match.length < 2) {
        return '';
    }
    if (decode) {
        return productMappings[match[1]];
    }

    return match[1];
}

export function urlParamsFromObject(obj) {
    const params = Object.keys(obj)
        .map(function (key) {
            if (obj[key] !== '') {
                return key + '=' + obj[key];
            }
        })
        .join('&');

    if (params.length === 0) {
        return '';
    }
    return encodeURIComponent(params);
}
